import type { SerializeOptions } from 'cookie';
import nookies from 'nookies_MUST_REMOVE_THIS_PACKAGE';

import type { CtxWithNextResponse, ResponseCtx } from './types';

type SetCookieOptions = {
  ctx?: CtxWithNextResponse;
} & SerializeOptions;

export const setCookie = (
  cookieName: string,
  cookieValue: string,
  { ctx, ...options }: SetCookieOptions = {}
): void => {
  nookies.set(ctx as ResponseCtx, cookieName, cookieValue, options);
};
